// extracted by mini-css-extract-plugin
module.exports = {"loginLink":"registrationForm-module--loginLink--kbQnv"};